import { c as _c } from "react/compiler-runtime";
import './child-bio.scss';
import { SkeletonImage } from '@sola/ark-core/atoms/skeleton-image/skeleton-image.tsx';
import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.tsx';
export const ChildBioSkeleton = () => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="ChildBio__media"><div className="xl:pr-comfy-xl rounded-lg"><SkeletonImage width="100%" height="auto" style={{
          aspectRatio: "3/4"
        }} borderRadius="0.5rem" /></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div><Skeleton height="3rem" width="80%" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mt-comfy-sm"><Skeleton height="2rem" width="40%" borderRadius="9999px" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="mt-comfy-lg flex flex-col gap-snug-lg"><Skeleton height="1.5rem" width="70%" /><Skeleton height="1.5rem" width="60%" /><Skeleton height="1.5rem" width="65%" /><Skeleton height="1.5rem" width="55%" /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="mt-comfy-lg flex flex-col gap-snug-md"><Skeleton height="1rem" width="100%" /><Skeleton height="1rem" width="100%" /><Skeleton height="1rem" width="95%" /><Skeleton height="1rem" width="90%" /></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="ChildBio__flex flex">{t0}<div className="ChildBio__content flex flex-col gap-comfy-md">{t1}{t2}{t3}{t4}<div className="mt-comfy-xl"><Skeleton height="3rem" width="60%" borderRadius="0.5rem" /></div></div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};